<template>
  <v-container fluid class="pa-0">
    <v-card>
      <v-card-title>
        <v-icon left>mdi-receipt-text-outline</v-icon>
        {{ $t('sites.purchase_invoices.title') }}
        <v-spacer />
        <v-btn color="primary" :loading="syncing" @click="refresh">
          <v-icon left>mdi-refresh</v-icon>
          {{ $t('sites.purchase_invoices.refresh') }}
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-alert v-if="!hasProject" type="warning" text dense class="mb-0">
          {{ $t('sites.purchase_invoices.no_project') }}
        </v-alert>

        <netvisor-purchase-invoice-table
          v-else
          :invoices="invoices"
          :loading="loading"
          :allocated-label="$t('sites.purchase_invoices.site_amount')"
          :no-data-text="$t('sites.purchase_invoices.no_invoices')"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import netvisorApi from '@/api/netvisor';
import NetvisorPurchaseInvoiceTable from '@/components/Netvisor/NetvisorPurchaseInvoiceTable';

export default {
  name: 'SiteNetvisorInvoices',
  components: { NetvisorPurchaseInvoiceTable },
  props: {
    site: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      invoices: [],
      loading: false,
      syncing: false,
    };
  },
  computed: {
    hasProject() {
      return !!(this.site && this.site.project);
    },
  },
  watch: {
    'site.id'() {
      this.loadInvoices();
    },
  },
  methods: {
    async loadInvoices() {
      if (!this.site || !this.site.id || !this.hasProject) return;
      this.loading = true;
      try {
        this.invoices = await netvisorApi.getSitePurchaseInvoices(this.site.id);
      } catch (error) {
        console.error('Error loading site purchase invoices:', error);
        this.showError(this.$t('sites.purchase_invoices.load_failed'));
      } finally {
        this.loading = false;
      }
    },

    async refresh() {
      this.syncing = true;
      try {
        await netvisorApi.syncPurchaseInvoices();
        await this.loadInvoices();
        this.showSuccess(this.$t('sites.purchase_invoices.refreshed'));
      } catch (error) {
        console.error('Error syncing purchase invoices:', error);
        this.showError(this.$t('sites.purchase_invoices.refresh_failed'));
      } finally {
        this.syncing = false;
      }
    },

    showSuccess(message) {
      this.$store.dispatch('showNotification', { color: 'success', message, timeOut: 2000 });
    },

    showError(message) {
      this.$store.dispatch('showNotification', { color: 'error', message, timeOut: 3000 });
    },
  },
  mounted() {
    this.loadInvoices();
  },
};
</script>
